import React from 'react';
import { Link } from 'react-router-dom';
import { FaSitemap, FaArrowLeft, FaHome, FaShoppingBag, FaLayerGroup, FaInfoCircle, FaEnvelope, FaShieldAlt, FaFileAlt } from 'react-icons/fa';

const Sitemap = () => {
  const sections = [
    {
      title: 'Main Pages',
      icon: <FaHome />,
      links: [
        { name: 'Home', path: '/', description: 'Welcome to Home Fashion Varanasi' },
        { name: 'Products', path: '/products', description: 'Browse our products' },
        { name: 'Collections', path: '/collections', description: 'Explore our collections' },
        { name: 'About Us', path: '/about', description: 'Learn about our story' },
        { name: 'Contact', path: '/contact', description: 'Get in touch with us' },
      ]
    },
    {
      title: 'Categories',
      icon: <FaLayerGroup />,
      links: [
        { name: 'Curtains', path: '/category/curtains', description: 'Premium curtains collection' },
        { name: 'Bedsheets', path: '/category/bedsheets', description: 'Luxury bedsheets' },
        { name: 'Wallpapers', path: '/category/wallpapers', description: 'Designer wallpapers' },
        { name: 'Mattresses', path: '/category/mattresses', description: 'Orthopedic mattresses' },
        { name: 'Blinds', path: '/category/blinds', description: 'Modern blinds' },
        { name: 'Rugs', path: '/category/rugs', description: 'Handwoven rugs' },
        { name: 'Towels', path: '/category/towels', description: 'Premium towels' },
        { name: 'Decoratives', path: '/category/decoratives', description: 'Home decoratives' },
        { name: 'Upholstery', path: '/category/upholstery', description: 'Upholstery fabrics' },
      ]
    },
    {
      title: 'Legal',
      icon: <FaShieldAlt />,
      links: [
        { name: 'Privacy Policy', path: '/privacy-policy', description: 'How we handle your data' },
        { name: 'Terms & Conditions', path: '/terms', description: 'Terms of service' },
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-5xl">
        {/* Back Button */}
        <Link to="/" className="inline-flex items-center gap-2 text-pink-500 mb-6 hover:gap-3 transition-all duration-300">
          <FaArrowLeft size={14} />
          Back to Home
        </Link>

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
              <FaSitemap className="text-purple-500 text-xl" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold">
              <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
                Sitemap
              </span>
            </h1>
          </div>
          <p className="text-gray-600">
            Find everything at Home Fashion Varanasi. Use this sitemap to navigate through our website.
          </p>
        </div>

        {/* Sitemap Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sections.map((section, idx) => (
            <div key={idx} className="bg-white rounded-2xl shadow-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center text-pink-500">
                  {section.icon}
                </div>
                <h2 className="text-lg font-bold text-gray-800">{section.title}</h2>
              </div>
              <ul className="space-y-3">
                {section.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    <Link 
                      to={link.path} 
                      className="block p-3 bg-gray-50 rounded-lg hover:bg-pink-50 transition-colors duration-300 group"
                    >
                      <span className="text-sm font-semibold text-gray-700 group-hover:text-pink-500">
                        {link.name}
                      </span>
                      <p className="text-xs text-gray-500 mt-1">{link.description}</p>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="mt-8 bg-gradient-to-r from-pink-500 to-blue-500 rounded-2xl shadow-xl p-8 text-white">
          <h2 className="text-xl font-bold mb-3">Need Help?</h2>
          <p className="text-sm opacity-90 mb-4">
            Can't find what you're looking for? Contact us and we'll help you.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/contact" className="px-4 py-2 bg-white text-pink-500 rounded-lg text-sm font-semibold hover:shadow-lg transition-all duration-300">
              Contact Us
            </Link>
            <a href="tel:8573035759" className="px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-lg text-sm font-semibold hover:bg-white/30 transition-all duration-300">
              Call: 8573035759
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;